import * as React from 'react'
import axios from '../../services/index'
import {useHistory} from 'react-router-dom'

//This component allow Admin to give access to a training to a selected user.
export const UserAddTraining: React.FunctionComponent = (props) => {

    interface IUserTraining {
        id : string,
        username : string,
        paidTraining : Array<any>
    }

    let emptyUser: IUserTraining = {
        id : '',
        username: '',
        paidTraining: []
    }

    const [user, setUser] = React.useState<IUserTraining>(emptyUser)
    const [trainingNameArray, setTrainingNameArray] = React.useState<Array<any>>([])
    const [notOwnedTrainingArray, setNotOwnedTrainingArray] = React.useState<Array<any>>([])
    const [userError, setUserError] = React.useState<string>()
    const [trainingError, setTrainingError]= React.useState<string>()
    const id = window.location.href.toString().split('/')[6]
    const currentToken = localStorage.getItem('access_token')
    let history = useHistory()


    React.useEffect(() => {
        axios.get('https://LaurenceBrun.eu.pythonanywhere.com/training/', {
            headers: {
                "Authorization" : `Bearer ${currentToken}`
            }
        })
        .then(function(response: any) {
            let RequestedArray = response.data.map((training: any) => {
                return {id: training.id, title:training.title, allowedUsers: training.allowedUsers}
            })
            setTrainingNameArray(RequestedArray)
        })
        .catch(function(error: any) {
            console.log(error)
            setTrainingError(error)
            alert('Une erreur est survenue ! Veuillez réessayer')
        })
    },[])

    React.useEffect(() => {
        axios.get(`https://LaurenceBrun.eu.pythonanywhere.com/users/${id}/`, {
            headers: {
                "Authorization" : `Bearer ${currentToken}`
            }
        })
        .then(function(response) {
            const RequestUser: IUserTraining = {
                id: response.data.id,
                username: response.data.username,
                paidTraining: response.data.paid_training,
            }
            setUser(RequestUser)
        })
        .catch(function(error) {
            console.log(error)
            setUserError(error)
            alert('Une erreur est survenue ! Veuillez réessayer')
        })
    },[])

    React.useEffect(() => {
        let requestArray = []
        for (let training of trainingNameArray) {
            if(!((training.id-1)in user!.paidTraining)) {
                requestArray.push(training)
            }
        }
        setNotOwnedTrainingArray(requestArray)
    },[user, trainingNameArray])

    const displayNotOwnedTraining = () => {
       return notOwnedTrainingArray.map((training: any) => {
            return(
                <option value={`{"id": "${training.id}", "users": "${training.allowedUsers}"}`}>{training.title}</option>
            )
        })
    }

    const handleSubmit = (event: any) => {
        event.preventDefault()
        if (event.target.training.value) {
            let training = event.target.training.value
            training = JSON.parse(training)
            let trainingId = training.id
            let allowedUsers = training.users.split(',')
            if (allowedUsers[0] === "") {
                allowedUsers[0] = `https://LaurenceBrun.eu.pythonanywhere.com/users/${user.id}/`
            }
            else {
                allowedUsers.push(`https://LaurenceBrun.eu.pythonanywhere.com/users/${user.id}/`)
            }
            let updateUsers = {
                "allowedUsers" : allowedUsers
            }

            axios.patch(`https://LaurenceBrun.eu.pythonanywhere.com/admintrainingusers/${trainingId}/`, updateUsers,
            {
                headers: {
                    "Authorization": `Bearer ${currentToken}`,
                    'Content-Type': 'application/json'
                } 
            })
            .then(function(response) {
                history.push('/admin/')
            })
            .catch(function(error) {
                console.log(error)
                alert("Une erreur est survenue ! Veuillez réessayer")
            })
        }
    }

    const displayErrors = () => {
        let uE = ""
        let tE = ""
        if(userError) {
            uE = userError
        }
        if(trainingError) {
            tE = trainingError
        }
        if(userError || trainingError) {
            return(
                <div>
                    <div>userError : {uE}</div>
                    <div>trainingError : {tE}</div>
                </div>
            )
        }
        else {
            return(
                <div></div>
            )
        }
    }

    return(
        <div className="Connect">
            <h2>Ajouter une formation à {user?.username}</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <select id="training" name="training">
                        {displayNotOwnedTraining()}
                    </select>
                </label><br />
                <input type="submit" value="ajouter" className="ConnectButton Connexion" />
            </form>
            {displayErrors}
        </div>
    )
}